import { inject } from "mobx-react";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Close from "@material-ui/icons/Close";
import RuleForm from "sections/RuleForm";

const Wrapper = styled.div`
  margin-top: 20px;
  padding: 0 50px;
`;

const EmptyIconButton = styled.div`
  flex: 0 0 48px;
`;

const Bar = styled.div`
  align-items: center;
  display: flex;
`;

const FormWrapper = styled.div`
  flex: 0 1 960px;
`;

class EditRule extends React.Component {
  CancelLink = React.forwardRef((props, ref) => (
    <Link ref={ref} to="/rules" {...props} />
  ));

  componentDidMount() {
    const { ruleStore } = this.props;
    const { id } = this.props.match.params;
    ruleStore.resetRuleAs(id);
  }

  render() {
    return (
      <Wrapper>
        <Bar>
          <IconButton component={this.CancelLink}>
            <Close />
          </IconButton>
          <Typography color="textSecondary" variant="h5">
            Edit Rule
          </Typography>
        </Bar>
        <Bar>
          <EmptyIconButton />
          <FormWrapper>
            <RuleForm />
          </FormWrapper>
        </Bar>
      </Wrapper>
    );
  }
}

export default inject("ruleStore")(EditRule);



// WEBPACK FOOTER //
// ./src/sections/EditRule.js